import Banner from "@/components/Banner";

export const CAMPUS_PENDING_ROSTER_COPY = {
  description: "You've already submitted a roster for this semester.",
  subText: "If you need to change it, contact PGA National.",
  checkFailed: "We couldn't confirm whether a roster is already pending. Try again, or contact PGA National."
} as const;

export function campusPendingRosterGate({
  isCampusOnlyUniversityStaff,
  loading,
  error,
  totalCount,
  universityReady = true
}: {
  isCampusOnlyUniversityStaff: boolean;
  loading: boolean;
  error?: unknown;
  totalCount?: number | null;
  universityReady?: boolean;
}) {
  const hasPendingReviewRoster = (totalCount ?? 0) > 0;
  const stillChecking = loading || (isCampusOnlyUniversityStaff && !universityReady);
  const pendingRosterCheckFailed = isCampusOnlyUniversityStaff && Boolean(error);
  const blockCampusResubmit = isCampusOnlyUniversityStaff && hasPendingReviewRoster;
  const showUploadRosterAction = !isCampusOnlyUniversityStaff || (!stillChecking && !error && !hasPendingReviewRoster);

  return {
    hasPendingReviewRoster,
    pendingRosterCheckFailed,
    blockCampusResubmit,
    showUploadRosterAction
  };
}

export function CampusPendingRosterBanner({ className }: { className?: string }) {
  return (
    <Banner
      variant="info"
      className={className}
      description={CAMPUS_PENDING_ROSTER_COPY.description}
      subText={CAMPUS_PENDING_ROSTER_COPY.subText}
      testId="campus-pending-roster-banner"
    />
  );
}

export function CampusPendingRosterCheckFailedBanner({ className }: { className?: string }) {
  return (
    <Banner
      variant="error"
      className={className}
      description={CAMPUS_PENDING_ROSTER_COPY.checkFailed}
      testId="campus-pending-roster-check-failed-banner"
    />
  );
}
